import { render, staticRenderFns } from "./backNav.vue?vue&type=template&id=6e41e252&scoped=true&"
import script from "./backNav.vue?vue&type=script&lang=js&"
export * from "./backNav.vue?vue&type=script&lang=js&"
import style0 from "./backNav.vue?vue&type=style&index=0&lang=css&"
import style1 from "./backNav.vue?vue&type=style&index=1&id=6e41e252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e41e252",
  null
  
)

export default component.exports